module.exports = __webpack_public_path__ + "static/q1_x-17f5f72ccaf3dd872426a3baf8bd23e2.png";